/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddOrUpdateGoodsVo } from './AddOrUpdateGoodsVo';
import {
    AddOrUpdateGoodsVoFromJSON,
    AddOrUpdateGoodsVoFromJSONTyped,
    AddOrUpdateGoodsVoToJSON,
    AddOrUpdateGoodsVoToJSONTyped,
} from './AddOrUpdateGoodsVo';
import type { GoodsMarketBarcodeVo } from './GoodsMarketBarcodeVo';
import {
    GoodsMarketBarcodeVoFromJSON,
    GoodsMarketBarcodeVoFromJSONTyped,
    GoodsMarketBarcodeVoToJSON,
    GoodsMarketBarcodeVoToJSONTyped,
} from './GoodsMarketBarcodeVo';

/**
 * 
 * @export
 * @interface ComposedGoodsVo
 */
export interface ComposedGoodsVo {
    /**
     * 商品ID
     * @type {number}
     * @memberof ComposedGoodsVo
     */
    id?: number;
    /**
     * 商品编号
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    code?: string;
    /**
     * 商品选项名
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    marketOptionName?: string;
    /**
     * 商品选项ID
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    marketOptionId?: string;
    /**
     * 商品入库条码
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    marketBarcode?: string;
    /**
     * 入库商品名
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    marketProNm?: string;
    /**
     * 第三方电商平台ID
     * @type {number}
     * @memberof ComposedGoodsVo
     */
    businessPlatformId?: number;
    /**
     * 商品数量
     * @type {number}
     * @memberof ComposedGoodsVo
     */
    initQuantity?: number;
    /**
     * 当前基础商品总量扣除其他合包占用后允许的最大套数，仅用于展示，保存时重新校验
     * @type {number}
     * @memberof ComposedGoodsVo
     */
    maxQuantity?: number;
    /**
     * 删除状态
     * @type {number}
     * @memberof ComposedGoodsVo
     */
    deleteStatus?: number;
    /**
     * 
     * @type {number}
     * @memberof ComposedGoodsVo
     */
    skuId?: number;
    /**
     * 
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    imgUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ComposedGoodsVo
     */
    totalPrice?: number;
    /**
     * 原产地
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    origin?: string;
    /**
     * 商品到期日期 yyyy-MM-dd
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    marketExpiryDate?: string;
    /**
     * 当前订单合包商品的平台条码快照列表
     * @type {Array<GoodsMarketBarcodeVo>}
     * @memberof ComposedGoodsVo
     */
    marketBarcodes?: Array<GoodsMarketBarcodeVo>;
    /**
     * 合包包装作业备注，仅后台维护
     * @type {string}
     * @memberof ComposedGoodsVo
     */
    combinedPackingRemark?: string;
    /**
     * 基础商品
     * @type {Array<AddOrUpdateGoodsVo>}
     * @memberof ComposedGoodsVo
     */
    baseGoods?: Array<AddOrUpdateGoodsVo>;
}

/**
 * Check if a given object implements the ComposedGoodsVo interface.
 */
export function instanceOfComposedGoodsVo(value: object): value is ComposedGoodsVo {
    return true;
}

export function ComposedGoodsVoFromJSON(json: any): ComposedGoodsVo {
    return ComposedGoodsVoFromJSONTyped(json, false);
}

export function ComposedGoodsVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComposedGoodsVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'code': json['code'] == null ? undefined : json['code'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'maxQuantity': json['maxQuantity'] == null ? undefined : json['maxQuantity'],
        'deleteStatus': json['deleteStatus'] == null ? undefined : json['deleteStatus'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'name': json['name'] == null ? undefined : json['name'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'marketExpiryDate': json['marketExpiryDate'] == null ? undefined : json['marketExpiryDate'],
        'marketBarcodes': json['marketBarcodes'] == null ? undefined : ((json['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeVoFromJSON)),
        'combinedPackingRemark': json['combinedPackingRemark'] == null ? undefined : json['combinedPackingRemark'],
        'baseGoods': json['baseGoods'] == null ? undefined : ((json['baseGoods'] as Array<any>).map(AddOrUpdateGoodsVoFromJSON)),
    };
}

export function ComposedGoodsVoToJSON(json: any): ComposedGoodsVo {
    return ComposedGoodsVoToJSONTyped(json, false);
}

export function ComposedGoodsVoToJSONTyped(value?: ComposedGoodsVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'businessPlatformId': value['businessPlatformId'],
        'initQuantity': value['initQuantity'],
        'maxQuantity': value['maxQuantity'],
        'deleteStatus': value['deleteStatus'],
        'skuId': value['skuId'],
        'imgUrl': value['imgUrl'],
        'name': value['name'],
        'totalPrice': value['totalPrice'],
        'origin': value['origin'],
        'marketExpiryDate': value['marketExpiryDate'],
        'marketBarcodes': value['marketBarcodes'] == null ? undefined : ((value['marketBarcodes'] as Array<any>).map(GoodsMarketBarcodeVoToJSON)),
        'combinedPackingRemark': value['combinedPackingRemark'],
        'baseGoods': value['baseGoods'] == null ? undefined : ((value['baseGoods'] as Array<any>).map(AddOrUpdateGoodsVoToJSON)),
    };
}

